import type { PropsWithChildren } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'
import type { ConversationMutationData } from '@mote/api'

export type PreloadedMoteConversationState =
  | ConversationMutationData
  | Omit<ConversationMutationData, 'conversation'>

export const PreloadedMoteConversationStateContext = createContext<{
  get: () => PreloadedMoteConversationState | null
  set: (c: PreloadedMoteConversationState | null) => void
}>({ get: () => null, set: () => void 0 })

export function PreloadedMoteConversationStateProvider(
  props: PropsWithChildren
) {
  const [state, setState] = useState<PreloadedMoteConversationState | null>(
    null
  )
  const value = useMemo(
    () => ({ get: () => state, set: setState }),
    [state, setState]
  )
  return (
    <PreloadedMoteConversationStateContext.Provider value={value}>
      {props.children}
    </PreloadedMoteConversationStateContext.Provider>
  )
}

export function usePreloadedMoteConversationStateContext() {
  return useContext(PreloadedMoteConversationStateContext)
}
